import index from './embed'

export default index